import { useRoutes } from "react-router";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LandingPage from './pages/LandingPage/LandingPage'
import SignUp from "./pages/SignUp/SignUp";
import Components from "./pages/Components/Components";
import PasswordReset from "./pages/PasswordReset/PasswordReset"
import Home from "./pages/Home/Home";
import DetalleServicio from "./pages/DetalleServicio/DetalleServicio";
import DetalleProveedor from "./pages/DetalleProveedor/DetalleProveedor";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail";
import UsersValidations from "./pages/UsersValidations/UsersValidations";
import PasswordChange from "../src/pages/PasswordChange/PasswordChange";
import ReviewService from "./Components/Organisms/ReviewService/ReviewService";
import SignInAdmin from "./pages/SignInAdmin/SignInAdmin";
import ControlPanel from "./pages/ControlPanel/ControlPanel";
import CreateService from "./pages/CreateService/CreateService";
import HomeNavigation from "./Components/Organisms/HomeNavigation/HomeNavigation";
import Profile from "./pages/Profile/Profile";
import ListFavorites from "./pages/ListFavorites/ListFavorites";
import ConfirmServicio from "./pages/ConfirmServ/ConfirmServ";
import MyServices from "./pages/MyServices/MyServices";
import EditarServicio from "./pages/EditarServicio/EditarServicio";
import MisCitas from "./pages/MisCitas/MisCitas";
import CrearHorarios from "./pages/CrearHorarios/CrearHorarios";
import AgendarCita from "./pages/AgendarCita/AgendarCita";
import { MapServices } from "./pages/MapServices/MapServices";
import PercentageReview from "./Components/Molecules/PercentageReview/PercentageReview";
import StarRatingReview from "./Components/Molecules/StarRatingReview/StarRatingReview";
import Reservations from "./pages/Reservations/Reservations";
import NotFound404 from "./pages/NotFound404/NotFound404";
import Nosotros from "./pages/Nosotros/Nosotros";
import { AcercaDe } from "./pages/AcercaDe/AcercaDe";

function App() {
  toast.configure()
  const routes = [
    {
      index: true,
      element: <LandingPage />
    },
    {
      path: '/signup',
      element: <SignUp />
    },
    {
      path: '/components',
      element: <Components />
    },
    {
      path: 'home',
      element: <HomeNavigation />,
      children: [
        {
          index: true,
          element: <Home />
        },
        {
          path: '/home/mapservices',
          element: <MapServices />
        },
        {
          path: '/home/:uidClient/new-service',
          element: <CreateService />
        },
        {
          path: '/home/:uidClient/list-favorites',
          element: <ListFavorites />
        },
        {
          path: '/home/chat',
          element: <div><h1>chat</h1></div>
        },
        {
          path: '/home/schedule',
          element: <div><h1>schedule</h1></div>
        },
        {
          path: '/home/detalleServicio/:id',
          element: <DetalleServicio />
        },
        {
          path: '/home/:uidClient/my-services',
          element: <MyServices />
        },
        {
          path: '/home/:uidClient/appointments',
          element: <MisCitas />
        },
        {
          path: '/home/:idService/crear-horarios',
          element: <CrearHorarios />
        },
        {
          path: '/home/servicios/:id/editar',
          element: <EditarServicio />
        },
        {
          path: '/home/:uidClient/reservations',
          element: <Reservations />
        },
      ]
    },
    {
      path: '/passwordReset',
      element: <PasswordReset />
    },
    {
      path: '/detalleProveedor/:id',
      element: <DetalleProveedor />
    },
    {
      path: '/email-verification',
      element: <VerifyEmail />
    },
    {
      path: '/user-validations',
      element: <UsersValidations />
    },
    {
      path: '/profile',
      element: <Profile />
    },
    {
      path: '/confirmServ',
      element: <ConfirmServicio />
    },
    {
      path: '/control-panel',
      element: <ControlPanel />
    },
    {
      path: '*',
      element: <NotFound404 />
    },
    {
      path: '/about',
      element: <Nosotros />
    },
    {
      path: '/acercaDe',
      element: <AcercaDe />
    }
  ]
  /*
  <div>
      <Routes>
        <Route path="/"/>
        <Route path="/signup"/>
        <Route path="/components" />
        <Route path='/home'> 
          <Route path='/home/chat'/>

          <Route path='/home/profile'/>
          <Route path='/home/schedule'/>

        </Route>
        <Route path="/passwordChange"/>
        <Route path="/passwordChange" element={<PasswordChange />} /> 
        <Route path="/passwordReset" element={<PasswordReset />} />
        <Route path="/detalle" element={<Detalle />} />
        <Route path="/test" element={<PasswordChange />} />
        <Route path="/email-verification" element={<VerifyEmail />} />
        <Route path="/user-validations" element={<UsersValidations />} />
        <Route path="/review" element={<ReviewService />} />
        <Route path="/admin" element={<SignInAdmin />} />
        <Route path="/control-panel" element={<ControlPanel />} />
         <Route path="/pago" element={<Pago/>} />
        <Route path="/passwordChange"/>
        <Route path="/passwordReset"/>
        <Route path="/detalleServicio/:id"/>
        <Route path="/detalleProveedor/:id"/>
        <Route path="/profile" />
        <Route path="/test" />
        <Route path="/email-verification"/>
        <Route path="/user-validations" />
        <Route path="/pago"/>
      </Routes>
    <div className="custom-scrollbar">
      {routing}
    </div>
    </div>
   */
  let routing = useRoutes(routes);
  return (
    <div>
      {routing}
      <ToastContainer />
    </div>
  );
}

export default App;
